(function ($) {
	$(document).on('ready', function () {
		var db = new Object();
		db.preLoad = function () {
			$('.page-loader').delay(400).fadeOut(200, function () {
				$('body').fadeIn();
			});
		}

		db.newsSlider = function () {
          		if ($('.owl-home-slider2').length) {
				$('.owl-home-slider2').owlCarousel({
					loop: true,
					margin: 0,
					nav: true,
					navText: ["<i class='fal fa-angle-left'></i>", "<i class='fal fa-angle-right'></i>"],
					items: 1,
					autoplay:true,
					animateOut: 'fadeOut',
					autoplayTimeout:1500,
					autoplayHoverPause:false,
					autoplaySpeed:1500

				})
			}
          
          	if ($('.owl-home-slider2').length) {
				$('.owl-home-slider2').owlCarousel({
					loop: true,
					margin: 0,
					nav: true,
					navText: ["<i class='fal fa-angle-left'></i>", "<i class='fal fa-angle-right'></i>"],
					items: 1,
					autoplay:true,
					animateOut: 'fadeOut',
					autoplayTimeout:1500,
					autoplayHoverPause:false,
					autoplaySpeed:1500

				})
			}
          
			if ($('.owl-quote').length) {
				$('.owl-quote').owlCarousel({
					loop:true,
					margin:28,
					nav:true,
					navText:["<i class='far fa-angle-left'></i>","<i class='far fa-angle-right'></i>"],
					responsive:{
							0:{
									items:1
							},
							768:{
									items:1
							},
							1000:{
									items:2
							}
					}
				})
			}

		}

		db.preLoad();

		db.newsSlider();
	 	new WOW({
      offset: 100,
       mobile: true
     }).init()


	 });
})(jQuery);